import { alpha, createTheme } from "@mui/material/styles";

const BORDER = "rgba(17, 24, 39, 0.08)";

export const theme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "#EEF0FF", // page lavender like UI
      paper: "#FFFFFF",
    },
    text: {
      primary: "#111827",
      secondary: alpha("#111827", 0.6),
    },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily:
      "Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial",
    fontSize: 13,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "none",
          border: `1px solid ${BORDER}`,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 8,
          fontWeight: 700,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          background: "#FFFFFF",
        },
        notchedOutline: {
          borderColor: BORDER,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${BORDER}`,
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 12,
          paddingRight: 12,
          fontSize: 13,
        },
        head: {
          background: "#FFFFFF",
          fontWeight: 700,
          fontSize: 12,
          color: alpha("#111827", 0.75),
          borderBottom: `1px solid ${BORDER}`,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          height: 20,
          fontSize: 12,
          borderRadius: 999,
          fontWeight: 700,
        },
        label: {
          paddingLeft: 8,
          paddingRight: 8,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
  },
});
